
import {  Avatar, Typography, Paper } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const StudentCard = ({ student, onClick }) => {
  return (
    <Paper 
      variant='section'
      onClick={onClick}
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap:'10px',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': { 
          transform: 'translateY(-3px)', 
          boxShadow: '0 8px 20px rgba(0,0,0,0.06)', 
          borderColor: 'primary.main'
        }
      }}
    >
      <Avatar 
          sx={{ 
              bgcolor: 'primary.light', 
              width: 35, 
              height: 35, 
          }}
      >
        <PersonIcon sx={{  color: 'primary.main' }} />
      </Avatar>
      
      <Typography 
        variant="subtitle1" 
      
        fontWeight="600" 
        color="text.primary"
        sx={{
            wordBreak: 'break-word',
            lineHeight: 1.4,
        }}
      >
        {student.person?.full_name || "اسم غير متوفر"}
      </Typography>
    </Paper>
  );
};

export default StudentCard;